import type {Word} from '$lib/classes/data/word';
import type {WordId} from './_primitives';

export class WordCollection {

    allWords: ReadonlyArray<Word> = []

    private wordIdToWord: Record<WordId, Word> = {};

    constructor() {}

    setWords(words: Word[]) {
        this.allWords = words;
        // TODO build wordidToWord map
    }

    getWord(wordId: WordId): Word | undefined {
        return this.wordIdToWord[wordId];
    }
}